import styled from 'styled-components';

export const MultiLevelDropdownWrapper = styled.div`
/* 📱 Mobile (accordion style) */
  @media (max-width: 768px) {
  .dropdown-menu{
    overflow-x: hidden;
    height: 70vh;
    overflow-y: scroll;
  }
  .multi-dropdown{
    margin-right: 5vw;
  }
}
`;
